export default {"src":"/_next/static/media/Add-Blue.9aa1c069.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};